export type AccountNotificationType = "None" | "VerifyEmail" | "FillInfo";

type LoginStepType =
    | "LoginWelcome" //(login after new registration)
    | "LoginPhone"
    | "LoginPass"
    | "ForgPinGen"
    | "ForgPinLog"
    | "ForgPinOk"
    | "ForgNewPass"
    | "ForgNewPassOk";
type RegistrationStepType = "RegPersonal" | "RegVerPhone" | "RegPinLog" | "RegPinOk" | "RegNewPass";
export type AuthenticationStepType = "None" | LoginStepType | RegistrationStepType;

const emptyFlow: AuthenticationStepType[] = ["None"];
const forgPassFlow: AuthenticationStepType[] = ["ForgPinGen", "ForgPinLog", "ForgPinOk", "ForgNewPass", "ForgNewPassOk", ...emptyFlow];
const welcomeFlow: AuthenticationStepType[] = ["LoginWelcome", ...forgPassFlow];

const loginFlow: AuthenticationStepType[] = ["LoginPhone", "LoginPass", ...forgPassFlow];
const registrationFlow: AuthenticationStepType[] = ["RegPersonal", "RegVerPhone", "RegPinOk", ...welcomeFlow];
const regPasswordFlow: AuthenticationStepType[] = ["RegPinLog", "RegPinOk", "RegNewPass", ...welcomeFlow];
const verifyPhoneFlow: AuthenticationStepType[] = ["RegPinLog", "RegPinOk", ...welcomeFlow];

export const authenticationFlows = {
    none: emptyFlow,
    login: loginFlow,
    registration: registrationFlow,
    regPassword: regPasswordFlow,
    verifyPhone: verifyPhoneFlow,
};
